import {Injectable} from "@angular/core";
import {capSQLiteSet, SQLiteDBConnection} from "@capacitor-community/sqlite";
import {v4} from "uuid";
import {StorageService} from "../../storage.service";
import {capSQLiteChanges} from "@capacitor-community/sqlite/src/definitions";
import {SQLRun} from "../../../pages/crud/SQLRun";

@Injectable()
export abstract class AbstractSQLService<T> {
  abstract nomeTabela: string
  public db: SQLiteDBConnection
  abstract agenciavel: boolean

  constructor(public storageService: StorageService) {
    this.db = storageService.db
  }


  toObject(row: any): T {
    return row
  }

  save(obj: any){
    const sqls= [this.montaReplace(obj),this.montaAlteracao(obj)]
    return this.db.executeSet(sqls.map(s=> s.tocapSQLiteSet()), true)
  }

  async delete(id: any){
    const sql = [
       new SQLRun(`DELETE FROM ${this.nomeTabela} where id=?`,[id]),
       new SQLRun('REPLACE INTO alteracoes (id, tabela, excluir) VALUES (?, ?, 1)',[id, this.nomeTabela])
    ]
    await this.db.executeSet(sql.map(s=> s.tocapSQLiteSet()), true)
  }


  async findById(id: any) {
    // const lista = await this.sql.executeSql(`select * from ${this.nomeTabela} where id='${id}'`, [])
    const lista = await this.db.query(`select * from ${this.nomeTabela} where id=?`, [id])
    const objs = lista.values as any[]
    return this.toObject(objs[0])
  }

  bulk(items: any[]): SQLRun[] {
    return items.map(o => {
      if (o?.excluido == true)
        return  new SQLRun(`DELETE
                      FROM ${this.nomeTabela}
                      WHERE id = ?`, [o.id])
      delete o.excluido
      return this.montaReplace(o)
    })
  }

  montaReplace(obj: any): SQLRun {

    obj.id = obj.id || v4()
    const colList = Object.keys(obj);
    const arrayP = colList.map(_ => '?').join(',')
    const valArr = Object.values(obj);

    const valores = this.converteParams(valArr)
    return new SQLRun(`REPLACE INTO ${this.nomeTabela} (${colList})
                  VALUES (${arrayP});`,valores)
  }

  converteParams(valArr: any[]): any[] {
    return valArr.map((value: any) => {
      // if (typeof value === 'string') return `'${value}'`
      if (value instanceof Date) return value.toISOString()
      if (Array.isArray(value)) return JSON.stringify(value)
      // if(value == undefined) return 'NULL'
      return value
    })
  }

  montaAlteracao(obj: any): SQLRun {
    return new SQLRun('REPLACE INTO alteracoes (id, tabela, valor) VALUES (?,?,?)', [obj.id, this.nomeTabela, JSON.stringify(obj)])
  }
}
